module.exports = __webpack_public_path__ + "img/television.5880db7a.png";